export default "__VITE_ASSET__CUtmYDJv__"